import { DeepReadonly, IUniversityKey } from 'types';
import { deepFreeze } from '../utils/deepFreeze';

export const universityKeys: DeepReadonly<IUniversityKey[]> = deepFreeze([
  { key: 'UoG', name: 'University of Greenwich' },
  { key: 'USW', name: 'University of South Wales' },
  { key: 'ARU', name: 'Anglia Ruskin University' },
  { key: 'BCU', name: 'Birmingham City University' },
  { key: 'STR', name: 'University of Strathclyde' }
]);

export * from './offices';
